import { erpAxios } from '..';

const getSuduznici = async (brojZahtjeva) => {
  const res = await erpAxios.get(`/suduznici/${brojZahtjeva}`);
  return res;
};

export default getSuduznici;
